//用户信息

<template>
<div class="">
	<header-vue></header-vue>
  <div class="container-l2">
  	<h1 class="h11">用户管理</h1>
  	<div class="clear marBottom20">
  		<div class="fl">
			<el-button @click="addComFlag = true"><i class="fa fa-plus"></i> 添加公司</el-button>
		</div>
		<el-select class="ml20" @change="changeStatus()" v-model="type" placeholder="请选择用户类型">
          <el-option v-for="(item,index) in formatRoleList" :key="index" :label="item.role_name" :value="item.id"></el-option>
        </el-select>
	  	<div class="search-box">
	  		<p class="log_warn" v-if="ifwarn" v-text="warntxt"></p>
			<input placeholder="请输入添加管理员的手机号" v-model="userTel" @keyup.enter="showUser()" class="log-input search-input" />
			<el-button @click="showUser()"> 搜 索 </el-button>
		</div>
  	</div>
  	
	
    <el-table
    	stripe
    	border
	    ref="multipleTable"
	    :data="userList"
	    tooltip-effect="dark"
	    style="width: 100%">
	    <el-table-column
	      type="index"
	      width="50">
	    </el-table-column>
	    <el-table-column
	      prop="real_name"
	      label="姓名">
	    </el-table-column>
	    <el-table-column
	      prop="username"
	      label="手机号码"
	      show-overflow-tooltip>
	    </el-table-column>
	    <el-table-column
	      prop="role_name"
	      label="身份"
	      show-overflow-tooltip>
	    </el-table-column>
	    <el-table-column
	      prop="company"
	      label="所属公司"
	      show-overflow-tooltip>
	    </el-table-column>
	    <el-table-column
	      prop="register_time"
	      label="日期"
	      :formatter="dateFormat">
	    </el-table-column>
		<el-table-column
	      prop="staus"
	      label="状态"
		  :formatter="formatStaus"
	      show-overflow-tooltip>
	    </el-table-column>
	    <el-table-column
          label="操作">
          <template slot-scope="scope">
            <el-button v-if="scope.row.administrators=='2'" type="text" size="small"
                       @click="removeUser(scope.$index, scope.row)">移除
            </el-button>
			<el-button type="text" size="small"
                       @click="showForbid(scope.$index, scope.row)">更改状态
            </el-button>
			<!-- 管理员的角色不能修改 -->
			<el-button type="text" size="small" v-if="scope.row.administrators!='2'"
                       @click="showChange(scope.$index, scope.row)">修改角色
            </el-button>
          </template>
        </el-table-column>
	  </el-table>

	  <br />
	  <div class="text-right">
			<el-pagination
				@current-change="handleCurrentChange"
			  :page-size="pageSize"
			  :pager-count="11"
			  layout="total, prev, pager, next"
			  :total="totalNum">
			</el-pagination>
		</div>
	  <!--搜索用户信息-->
		<el-dialog title="添加管理员" :visible.sync="userDetail" width="500px" >
		    <div class="userInfo" v-if="addUser.username">
				<el-form :model="addUser">
					<el-form-item label="姓名" :label-width="formLabelWidth">
				    	<span v-text="addUser.real_name"></span>
				    </el-form-item>
				    <el-form-item label="手机号码" :label-width="formLabelWidth">
				    	<span v-text="addUser.username"></span>
				    </el-form-item>
				    <el-form-item label="注册时间" :label-width="formLabelWidth">
				    	<span v-text="addUser.register_time"></span>
				    </el-form-item>
				    <el-form-item :model="noAdminCompanies" label="所属公司" :label-width="formLabelWidth" prop="area">
				    	<span v-if="beforeCompany!=''&&beforeCompany!='0'" v-text="addUser.company_name"></span>
			            <el-select v-if="beforeCompany==''||beforeCompany=='0'" v-model="addUser.company_id" placeholder="请选择">
			              <el-option v-if="area.user_id==0" v-for="area in noAdminCompanies" :key="area.id" :label="area.company" :value="area.id"></el-option>
			            </el-select>
			        </el-form-item>
				</el-form>
				
			</div>
			<div class="userInfo" v-if="!addUser.username">
				<h4>你搜索的用户不存在！</h4>
			</div>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="userDetail = false">关闭</el-button>
			    <el-button type="primary" v-if="beforeCompany==''||beforeCompany=='0'" @click="confirmAddNewUser()">确认添加</el-button>
			  </div>
		</el-dialog>
		<!--移除提示框-->
		<el-dialog title="提示" :visible.sync="removeUserFlag" width="500px" >
		    <div class="userInfo">
				<h4>确认移除该管理员用户吗？</h4>
			</div>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="removeUserFlag = false">关闭</el-button>
			    <el-button type="primary" @click="confirmRemovUser()">确认移除</el-button>
			  </div>
		</el-dialog>
		<!--修改角色提示框-->
		<el-dialog title="提示" :visible.sync="changeFlag" width="500px" >
		    <div class="userInfo">
				<!-- 不能修改为管理员和超级管理员 -->
				<el-select class="ml20" v-model="changeId" placeholder="请选择角色类型">
					<el-option v-if="item.id!=3 && item.id!=2" v-for="(item,index) in roleList" :key="index" :label="item.role_name" :value="item.id"></el-option>
				</el-select>
			</div>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="changeFlag = false">取消</el-button>
			    <el-button type="primary" @click="changeRole()">确认</el-button>
			  </div>
		</el-dialog>
		<!--禁止提示框-->
		<el-dialog title="提示" :visible.sync="forbidFlag" width="500px" >
		    <div class="userInfo">
				<p>更改用户状态后会影响用户的登录情况<br/>
					您确认要修改状态吗？</p>
			</div>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="forbidFlag = false">取消</el-button>
			    <el-button type="primary" @click="forbidUser()">确认</el-button>
			  </div>
		</el-dialog>
		<!--添加公司-->
		<el-dialog title="添加公司" :visible.sync="addComFlag" width="500px">
        
	        <el-form>
	          <el-form-item :model="company_name" label="公司名称" :label-width="formLabelWidth" prop="area">
	            <el-input v-model="company_name" auto-complete="off"></el-input>
	          </el-form-item>
	        </el-form>
	        <div slot="footer" class="dialog-footer">
	          <el-button @click="addComFlag=false">取 消</el-button>
	          <el-button type="primary" @click="saveCompany()">保 存</el-button>
	        </div>
	    </el-dialog>

	    
	  </div>

</div>
</template>
<script>
	export default {
		mounted() {
			this.$nextTick(function(){
				this.getRolelist();
		  		this.getUserList();
		  	})
    	},
		components:{
		},
		data() {
	      return {
	      	userDetail:false,
	      	removeUserFlag:false,
	        userList:[],
	        multipleSelection: [],
	        userTel:"",
	        addUser:{},
	        removeIndex:"",
	        removeRow:{},
	        noAdminCompanies:[],
	        addComFlag:false,
	        company_name:"",
	        formLabelWidth:'90px',
	        beforeCompany:'',
	        ifwarn:false,
		  	warntxt:'',
		  	type:1,
		  	nowPage:1,
		  	pageSize:12,
			totalNum:0,
			roleList:[],
			forbidFlag:false,
			forbidRow:{},
			changeFlag:false,
			changeUser:{},
			// 修改角色ID
			changeId:null
	      }
		},
		computed: {
			formatRoleList: function(){
				let newList = this.roleList.filter(function(value){
					return value.id != 3;
					
				})
				return newList;
			}
		},
		methods:{
			handleCurrentChange(val) {
		        this.nowPage = val;
		        this.getUserList();
		      },
		     changeStatus(){
		     	this.nowPage = 1;
		     	this.getUserList();
		     	/*console.log(this.nowPage);
		     	console.log(this.totalNum);*/
			 },
			 
			formatStaus(row, column){
				switch(parseInt(row.staus)){
					case 1:
						return "启用";
						break;
					case 2:
						return "禁用";
						break;
					
				}
			},
			
			getUserList(){
				this.userList = [];
				let valiCodeParams={
					uid:this.getCookie('uid'),
			  		timestamp:Date.parse( new Date()),
			  		terminalId:4,
			  		type:this.type||'',
		  			company_id:this.getCookie('company_id'),
		  			page:this.nowPage.toString(),
	  				pagesize:this.pageSize.toString(),
		  		};
		  		this.sign(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/AdministratorsList/AdministratorsList",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.status==1 & res.data.data!=null){
		        		if(res.data.data.name){
		        			this.userList = res.data.data.name || [];
		        		}
		        		
		        		if(res.data.data.pagecount){
		        			this.totalNum = parseInt(res.data.data.pagecount);
		        		}
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
		  				  		
			},
			showChange(index,row){
				this.changeFlag = true;
				this.changeUser = row;
				this.changeId = parseInt(row.administrators);
			},
			changeRole(){
				let valiCodeParams={
					uid:this.getCookie('uid'),
					user_id:this.changeUser.uid || "",
					role_id:this.changeId,
			  		timestamp:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		this.sign(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain+"/home/UserRole/UserRole",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.status==1){
		        		this.changeFlag = false;
		        		this.$message.success(res.data.msg);
		        		this.getUserList();
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);
		        	}else{
						this.$message.error(res.data.msg);
		        	}
		  		});
		  				  		
			},
			showForbid(index,row){
				 this.forbidRow = row;
				 this.forbidFlag = true;
			 },
			//  改变客户状态，禁用启用
			forbidUser(){
				// 给用户赋值相反的状态
				var state;
				if(this.forbidRow.staus==1){
					state=2;
				}else{
					state=1;
				}
				let valiCodeParams={
					uid:this.getCookie('uid'),
					user_id: this.forbidRow.uid || '',
					state:state,
					timestamp:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		this.sign(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain+"/home/UserState/UserState",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.status==1){
						this.forbidFlag = false;
		        		this.$message.success(res.data.msg);
		        		this.getUserList();
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
			},
			getRolelist(){
				let roleListParams = {
					uid: this.getCookie("uid"),
					token: this.getCookie("token"),
					time: Date.parse(new Date()),
					terminalId: 4
				};
				this.sign2(roleListParams);
				this.$ajax.post(this.$store.state.domain2 + "/admin/Role/rolelist",this.$qs.stringify(roleListParams),{
						emulateJSON: true
					}).then(res => {
					if (res.data.code == "200") {
						this.roleList = res.data.data || [];
					} else if (res.data.code == 10008) {
						this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);
					} else {
						//console.log(res.data.msg);
					}
					});
		  				  		
			},
			showUser(){
				
				/*获取没有管理员公司的列表*/
		  		let companyListParams={
					uid:this.getCookie('uid'),
			  		timestamp:Date.parse( new Date()),
			  		terminalId:4,
		  		};
		  		this.sign(companyListParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/CompanyList/CompanyList",this.$qs.stringify(companyListParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.status==1){
		        		this.noAdminCompanies = res.data.data || [];
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
				
				this.ifwarn = false;
				this.warntxt = '';
				var reg=11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
				if(this.userTel==""){
					this.ifwarn = true;
					this.warntxt = '手机号不能为空';
				}
				else if(!reg.test(this.userTel)){
					this.ifwarn = true;
					this.warntxt = '请输入正确的手机号码';
				}else{
					this.getUserList();
					this.userDetail = true;
					let valiCodeParams={
						uid:this.getCookie('uid'),
				  		timestamp:Date.parse( new Date()),
				  		terminalId:4,
			  			keyword:this.userTel,
			  		};
			  		this.sign(valiCodeParams);
			  		this.$ajax.post(this.$store.state.domain+"/Home/UserFind/UserFind",this.$qs.stringify(valiCodeParams),{
			            emulateJSON: true
			        }).then(res=>{
			        	if(res.data.status==1){
			        		this.addUser = res.data.data || {};
			        		this.beforeCompany = res.data.data.company_id || '';
			        		let date = this.addUser.register_time;
			        		if( date == '' || date == null || date == undefined){
								date = ''
							}else {
								this.addUser.register_time = this.$moment(date*1000).format("YYYY-MM-DD")
							}
			        	}else if(res.data.code==10008){
			        		this.delCookie('username');
							this.$router.push('/login/');
							this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);
			        	}else{
			        		//console.log(res.data.msg);
			        	}
			  		});
				}
				
			},
			removeUser(index,row){
				this.removeUserFlag = true;
				this.removeRow = row;
			},
			confirmRemovUser(){
				let valiCodeParams={
					uid:this.getCookie('uid'),
			  		timestamp:Date.parse( new Date()),
			  		terminalId:4,
		  			username:this.removeRow.username,
		  			company_id:this.removeRow.company_id,
		  		};
		  		this.sign(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/AdministratorsDel/AdministratorsDel",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.status==1){
		        		this.removeUserFlag = false;
		        		this.$message.success(res.data.msg);
		        		this.getUserList();
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
			},
			saveCompany(){
				if(this.company_name!=""){
					let saveCompanyParams={
						uid:this.getCookie('uid'),
				  		timestamp:Date.parse( new Date()),
				  		terminalId:4,
			  			company_name:this.company_name
			  		};
			  		this.sign(saveCompanyParams);
			  		this.$ajax.post(this.$store.state.domain+"/Home/CompanyAdd/CompanyAdd",this.$qs.stringify(saveCompanyParams),{
			            emulateJSON: true
			        }).then(res=>{
			        	this.addComFlag = false;
			        	if(res.data.status==1){
			        		this.$message.success(res.data.msg);
			        		
			        	}else if(res.data.code==10008){
			        		this.delCookie('username');
							this.$router.push('/login/');
							this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);
			        	}else{
			        		//console.log(res.data.msg);
			        		this.$message.error(res.data.msg);
			        	}
			  		});
			  		this.company_name= "";
				}
				
			},
			//公司添加管理员
			confirmAddNewUser(){
			if(this.addUser.company_id && this.addUser.company_id!='0'){
				this.userDetail = true;
				let valiCodeParams={
					uid:this.getCookie('uid'),
			  		timestamp:Date.parse( new Date()),
			  		terminalId:4,
		  			company_id:this.addUser.company_id,
		  			username:this.addUser.username
		  		};
		  		this.sign(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/AdministratorsAdd/AdministratorsAdd",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.status==1){
		        		this.userDetail = false;
		        		this.$message.success(res.data.msg);
		        		this.getUserList()
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
							this.$router.push('/login/');
							this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
			}else{
				this.$message.success("请选择对应公司或者新建公司后添加对应公司");
			}
				
			}
		}
	}

</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/setmanager.vue